//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export function saveBlob(blob: BlobPart, fileName: string, headers: any) {
  const a = document.createElement('a');
  const dest = document.body;
  a.setAttribute('style', 'display: none');
  dest.appendChild(a);
  const csv = 'application/csv';
  const contentType = headers['content-type'] || csv;
  const binaryData = [];
  binaryData.push(blob);
  const url = URL.createObjectURL(new Blob(binaryData, { type: contentType }));

  a.setAttribute('href', url);

  a.setAttribute('download', fileName);

  a.click();

  // Appease Firefox by waiting 5 seconds before revoking the object URL to free memory
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 5000);
}
